import {algoliasearch} from "algoliasearch";
import {ID, KEY, KEYWRITE} from "../Constantes";

export const borrarRegistro = ({coleccion, id}) => {



    const client = algoliasearch(ID, KEYWRITE);



    // Search for "query string" in the index "contacts"
    return client.deleteObject({ indexName: coleccion, objectID: id })





}